export default "__VITE_ASSET__BQaBnAP9__"